import GlobalTemplatesChannel from './global-templates-channel';

const isGlobalTemplatesActiveChannel = (activeChannel: number | null) => {
  if (GlobalTemplatesChannel.channel === undefined) return false;
  if (activeChannel === undefined) return false;
  return activeChannel === GlobalTemplatesChannel.channel;
};

export default isGlobalTemplatesActiveChannel;
